import { useEffect, useState, useMemo } from "react";
import { ScrollArea } from "../components/ui/scroll-area";
import { listarLogs } from "../lib/api";

const corNivel = (n) => {
    switch ((n || "").toLowerCase()) {
        case "erro": return "text-red-400";
        case "aviso": return "text-yellow-400";
        case "info": return "text-zinc-300";
        case "console": return "text-cyan-400";
        default: return "text-zinc-400";
    }
};

export default function AbaLogs({ botId, logsAoVivo }) {
    const [historico, setHistorico] = useState([]);

    useEffect(() => {
        (async () => {
            try { setHistorico(await listarLogs(botId, 200)); } catch {}
        })();
    }, [botId]);

    const todos = useMemo(() => {
        const mapa = new Map();
        for (const r of logsAoVivo) mapa.set(r.id, r);
        for (const r of historico) if (!mapa.has(r.id)) mapa.set(r.id, r);
        return Array.from(mapa.values());
    }, [logsAoVivo, historico]);

    return (
        <div className="bg-zinc-900 border border-zinc-800 rounded-md">
            <div className="px-3 py-2 text-[10px] uppercase tracking-wider text-zinc-500 font-mono border-b border-zinc-800">
                Logs do bot ({todos.length})
            </div>
            <ScrollArea className="h-[500px]">
                {todos.length === 0 ? (
                    <div className="text-center text-zinc-600 py-12 text-sm">Sem logs.</div>
                ) : (
                    <div data-testid="lista-logs">
                        {todos.map((log) => (
                            <div key={log.id} className="grid grid-cols-[80px_60px_1fr] gap-3 text-xs font-mono px-3 py-1.5 border-b border-zinc-800/50">
                                <span className="text-zinc-600">{new Date(log.criado_em).toLocaleTimeString("pt-BR")}</span>
                                <span className={`uppercase ${corNivel(log.nivel)}`}>{log.nivel}</span>
                                <span className="text-zinc-300 break-all">{log.mensagem}</span>
                            </div>
                        ))}
                    </div>
                )}
            </ScrollArea>
        </div>
    );
}
